import { LOGGER_CACHE_DATA_KEY } from 'src/common';
import { ApplicationStep } from 'src/features/common';

export type LoggingCache = {
  traceId: string;
  app: string;
};

export const getLoggingTraceId = (): string => {
  const cache = JSON.parse(sessionStorage.getItem(LOGGER_CACHE_DATA_KEY) ?? '{}') as LoggingCache;

  return cache.traceId;
};

export const getParamsFromUrl = (url: string): Record<string, any> => {
  const splitUrl = url.split('?');
  const params = splitUrl.length > 1 ? splitUrl[1].split('&') : [];

  const result = params.reduce((acc: Record<string, any>, curr) => {
    const p = curr.split('=');
    acc[p[0]] = p[1];

    return acc;
  }, {});

  return result;
};

export const getCurrentStep = (steps?: ApplicationStep[], currentStepIndex?: number) => ({
  subStepName: (steps && steps[currentStepIndex!])?.pageName,
});

// when the service is down the apis return html
// this makes the response an object
export const getResponseAsObject = (response: any): Record<string, any> =>
  typeof response === 'object' ? response : { result: `${response}` };
